import { defineComponent as _defineComponent } from 'vue'
import { useLandsideNavigationStore } from 'pinia/landside_navigation'
import { onBeforeUnmount, onMounted } from 'vue'
import LandsideFooter from 'vuecomponents/LandsideFooter.vue'
import LandsideHeader from 'vuecomponents/LandsideHeader.vue'
import LandsideMain from 'vuecomponents/LandsideMain.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideApp',
  setup(__props) {

onMounted(() => {
  window.addEventListener('popstate', useLandsideNavigationStore().switchPageToUrlParams)
})

onBeforeUnmount(() => {
  window.removeEventListener('popstate', useLandsideNavigationStore().switchPageToUrlParams)
})

return { __sfc: true,LandsideFooter, LandsideHeader, LandsideMain }
}

})